import React from 'react';
import {
  ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { formatNumber } from '../../utils/chartDataUtils';
import styles from '../../styles/Team.module.css';

const GrowthChart = ({ data }) => {
  const chartData = data;

  if (!chartData || chartData.length === 0) {
    return (
      <div className={styles.chartPlaceholder}>
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>📈</div>
          <h3>No Growth Data Available</h3>
          <p>Follower growth data will appear here once you have activity in the selected time period.</p>
        </div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart data={chartData}>
        <defs>
          <linearGradient id="newFollowersGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#10b981" stopOpacity={0.9}/>
            <stop offset="95%" stopColor="#10b981" stopOpacity={0.3}/>
          </linearGradient>
          <linearGradient id="unfollowsGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ef4444" stopOpacity={0.9}/>
            <stop offset="95%" stopColor="#ef4444" stopOpacity={0.3}/>
          </linearGradient>
          <linearGradient id="netGrowthGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.9}/>
            <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0.3}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" strokeOpacity={0.3} />
        <XAxis 
          dataKey="date" 
          stroke="#9ca3af"
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis 
          stroke="#9ca3af"
          fontSize={12}
          tickFormatter={(value) => formatNumber(value)}
          tickLine={false}
          axisLine={false}
        />
        <Tooltip 
          contentStyle={{
            backgroundColor: '#1f2937',
            border: '1px solid #374151',
            borderRadius: '12px',
            color: '#f9fafb',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(10px)'
          }}
          formatter={(value, name) => [formatNumber(value), name]}
          labelStyle={{ color: '#6366f1', fontWeight: 'bold' }}
        />
        <Legend 
          wrapperStyle={{
            paddingTop: '20px',
            color: '#f9fafb'
          }}
        />
        <Bar 
          dataKey="newFollowers" 
          fill="url(#newFollowersGradient)"
          radius={[4, 4, 0, 0]}
          name="New Followers"
        />
        <Bar 
          dataKey="unfollows" 
          fill="url(#unfollowsGradient)"
          radius={[4, 4, 0, 0]}
          name="Unfollows"
        />
        <Line 
          type="monotone" 
          dataKey="netGrowth" 
          stroke="#8b5cf6" 
          strokeWidth={3}
          dot={{ 
            fill: '#8b5cf6', 
            strokeWidth: 2, 
            r: 5,
            stroke: '#ffffff',
            filter: 'drop-shadow(0 2px 4px rgba(139, 92, 246, 0.3))'
          }}
          activeDot={{ 
            r: 8, 
            stroke: '#ffffff', 
            strokeWidth: 2,
            fill: '#8b5cf6',
            filter: 'drop-shadow(0 4px 8px rgba(139, 92, 246, 0.4))'
          }}
          name="Net Growth"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default GrowthChart; 